var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({attrs:{"id":_vm.svgContainerId}},_vm.treeContainerHandlers),[_c('svg',{attrs:{"id":_vm.svgId}}),_c('NodeContextMenu',{ref:"NodeContextMenu",on:{"action":_vm.doContextAction}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }